export const pageStyles = {
    pagePaperStyle: {
        borderRadius: 0,
        padding: 3,
        maxHeight: "calc(100% - 64px)",
        display: "flex",
        flexDirection: "column",
        width: '100%',
        overflowY: 'hidden'
        // height: '100vh',
    }
}